import {Pipe, PipeTransform} from "@angular/core";
import {CameraViewMode} from "@models";

@Pipe({
	name: "cameraViewModeToIndex",
	pure: true,
	standalone: false,
})
export class CameraViewModeToIndexPipe implements PipeTransform {
	transform(cameraViewMode: CameraViewMode) {
		return <number>cameraViewMode - 1;
	}
}
